import i18n from '@/utils/i18n';
import { getInvoiceData, InvoiceDataInput } from './InvoiceDataCalculation';

export async function getDepositClearingCsvBlob(data: InvoiceDataInput) {
  const depositClearingData = await getInvoiceData(data);

  if (
    depositClearingData == null ||
    Object.keys(depositClearingData).length === 0
  ) {
    return new Blob([], { type: 'text/csv' });
  }

  const csvData: any[] = [];

  const headerRow = [
    i18n.t('DepositClearingTable:location'),
    i18n.t('DepositClearingTable:containerTypeId'),
    i18n.t('DepositClearingTable:containerTypeName'),
    i18n.t('DepositClearingTable:delivered'),
    i18n.t('DepositClearingTable:returnedDirty'),
    i18n.t('DepositClearingTable:returnedClean'),
    i18n.t('DepositClearingTable:tooManyReturned'),
    i18n.t('DepositClearingTable:tooFewReturned'),
  ];

  csvData.push(headerRow);

  const sortedDepositClearingData = [...Object.keys(depositClearingData)].sort(
    (a, b) => a.localeCompare(b),
  );

  for (const locationName of sortedDepositClearingData) {
    const locationData = depositClearingData[locationName];

    csvData.push([locationName]);

    let rowsAdded = 0;
    for (const containerData of locationData) {
      const hasAnyAmount = [
        containerData.delivered,
        containerData.returnDirty,
        containerData.returnClean,
        containerData.tooManyReturned,
        containerData.tooFewReturned,
      ].some((amount) => {
        return amount > 0;
      });

      if (!hasAnyAmount) {
        continue;
      }

      const row = [
        '',
        containerData.itemTypeId,
        containerData.itemTypeName,
        containerData.delivered,
        containerData.returnDirty,
        containerData.returnClean,
        containerData.tooManyReturned,
        containerData.tooFewReturned,
      ];

      csvData.push(row);
      rowsAdded++;
    }

    if (rowsAdded === 0) {
      csvData.push(['-']);
    }

    csvData.push([]);
  }

  const csv = csvData.map((r) => r.join(';')).join('\n');

  return new Blob([csv], { type: 'text/csv' });
}
